<template>
    <div id="icon-title-value-card-component">
        <div class="pa-4 rounded-xl" style="background-color: #f4f4f4">
            <div class="d-flex align-center gap-2 mb-4">
                <div class="icon-container d-flex align-center justify-center rounded-circle">
                    <v-icon color="primary">
                        {{ icon }}
                    </v-icon>
                </div>
                <p class="font-18 font-weight-bold mb-0">{{ title }}</p>
            </div>

            <div class="d-flex justify-space-between">
                <div class="font-24 font-weight-bold">
                    <slot name="value">
                        <p>{{ value }}</p>
                    </slot>
                </div>
                <div v-if="date">
                    <v-chip color="primary" outlined small>
                        <span class="primary--text">{{ formatDateFromNow(date) }}</span>
                        <v-tooltip activator="parent" open-delay="300" top>
                            <span>{{ date }}</span>
                        </v-tooltip>
                    </v-chip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IconTitleValueCardComponent',
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
        },
        date: {
            type: String,
            required: false,
        },
    },
    methods: {
        formatDateFromNow(date) {
            return date
        },
    },
}
</script>

<style scoped>
.icon-container {
    min-width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #e9e9e9;
}
</style>
